@if (gebaeude) {
  <cap-content-header>
    <cap-title>
      {{ currentVersion | kompaktGebaeudeMaster: gebaeude.gebaeudeAufGrundstueck[0] }}
    </cap-title>
  </cap-content-header>
}

@if (gebaeude) {
  <div class="row">
    <div class="col-md-12 col-12">
      <cap-gebaeude-kopfdaten [gebaeude]="gebaeude" [version]="currentVersion"></cap-gebaeude-kopfdaten>
      <cap-rubrik [id]="'eingangadressen'" [isClosable]="false" [isOpen]="true">
        <ng-container title>
          <h3 class="mb-0">{{ "GebäudeeingangsadresseAdressen" | translate }}</h3>
        </ng-container>
        <cap-gebaeude-eingangsadressen [eingangAdressen]="gebaeude.eingangAdressen"></cap-gebaeude-eingangsadressen>
      </cap-rubrik>
      <cap-rubrik [id]="'aufGrundstueck'" [isClosable]="false" [isOpen]="true">
        <ng-container title>
          <h3 class="mb-0">{{ "StehtAufFolgendenGrundstuecken" | translate }}</h3>
        </ng-container>
        <cap-gebaeude-auf-grundstueck [gebAufGrundstueck]="gebaeude.gebaeudeAufGrundstueck"></cap-gebaeude-auf-grundstueck>
      </cap-rubrik>
    </div>
  </div>
} @else {
  <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
}
